var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropdown',{staticClass:"my-dropdown-toggle",attrs:{"options":_vm.langArray,"selected":_vm.$i18n.locale,"placeholder":_vm.lang.name,"closeOnOutsideClick":true},on:{"updateOption":_vm.methodToRunOnSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }